import React from 'react';
import Spinner from 'Shared/Spinner';
import classnames from 'classnames';
import * as styles from './base.scss';
const timeout = 300;
export default class Loader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: props.isVisible,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isVisible) {
            clearTimeout(this.visibilityTimer);
            this.visibilityTimer = setTimeout(() => {
                this.setState({ isVisible: true });
            }, timeout);
        }
        else {
            if (this.visibilityTimer) {
                clearTimeout(this.visibilityTimer);
                this.visibilityTimer = null;
            }
            this.setState({ isVisible: false });
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = this.state.isVisible !== nextState.isVisible;
        if (!shouldUpdate) {
            console.info('Ignoring update to Loader');
        }
        return shouldUpdate;
    }
    render() {
        return (React.createElement(Spinner, { key: "spinner", animate: this.state.isVisible, className: classnames(styles.base, {
                [styles.visible]: this.state.isVisible,
            }) }));
    }
}
